// extracted by mini-css-extract-plugin
export default {"icon-btn":"IconButton_icon-btn__B-87r"};